import { Reveal } from "@/lib/motion";
import { ArrowRight } from "lucide-react";
import { useSiteContent } from "@/lib/useSiteContent";

export default function Hero() {
  const c = useSiteContent().hero;
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full flex items-end overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url('${c.background_image}')` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70" />
      <div className="grain" />

      <div className="relative w-full max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-32 pt-40 md:pt-48">
        <Reveal>
          <p className="eyebrow text-[#C9A469] uppercase">{c.eyebrow}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h1
            data-testid="hero-heading"
            className="font-serif-luxe text-white text-[2.6rem] leading-[1.05] md:text-[4.4rem] md:leading-[1.02] mt-6 max-w-4xl"
          >
            {c.heading_line1}{" "}
            <em className="not-italic text-[#C9A469]">{c.heading_accent}</em>
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-2xl mt-8 font-light">
            {c.subheading}
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href={c.cta_href} data-testid="hero-cta-schedule" className="btn-luxe">
              {c.cta_label} <ArrowRight size={16} strokeWidth={1.4} />
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.5}>
          <div className="mt-20 pt-8 border-t border-white/15 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl">
            {(c.trust_stats || []).map((s, i) => (
              <div key={i} data-testid={`trust-stat-${i}`}>
                <div className="font-serif-luxe text-white text-3xl md:text-4xl">{s.k}</div>
                <div className="text-white/60 text-xs md:text-sm mt-2 tracking-[0.12em] uppercase">{s.v}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
